import {SalesTicketItemVo} from '../../common/shared/api/nicolas/vo/SalesTicketItemVo.interface';
import {SalesTicketItem} from '../generated/types';
import {createSaleType} from './SaleType';
import {createTicketType} from './TicketType';

export function createSalesTicketItem({
  ticket_uid,
  ticket_type,
  series_title,
  item_count,
  price,
  create_dt,
  sale_type,
  pay_id,
  qty,
  paid_num,
  ticket_expire_dt,
  series_id,
  category,
  sub_category,
}: SalesTicketItemVo): SalesTicketItem {
  return {
    ticketUid: ticket_uid,
    ticketType: ticket_type ? createTicketType(ticket_type) : ticket_type,
    seriesTitle: series_title,
    itemCount: item_count,
    price,
    createDt: create_dt,
    saleType: sale_type ? createSaleType(sale_type) : sale_type,
    payId: pay_id ? BigInt(pay_id).toString() : undefined,
    qty,
    paidNum: paid_num,
    ticketExpireDt: ticket_expire_dt,
    seriesId: series_id,
    category,
    subCategory: sub_category,
  };
}
